import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { SidebarItem, sidebarMenu } from 'src/app/layouts/sidebar-menu';
import { AppCore } from 'src/app/utils/classes/app-core';

@Component({
  selector: 'app-sidebar-menu-by-roles',
  templateUrl: './sidebar-menu-by-roles.component.html',
  styleUrls: ['./sidebar-menu-by-roles.component.scss'],
})
export class SidebarMenuByRolesComponent extends AppCore implements OnInit, OnChanges, OnDestroy {
  @Input() roles: string[] = [];

  sidebarMenu: SidebarItem[] = [];
  filterSidebarMenu: SidebarItem[] = [];

  Subscriptions: Subscription;
  constructor(private appService: AppService) {
    super();
  }

  ngOnInit(): void {
    const getSidebarMenu$ = this.appService.getSidebarMenu$.subscribe((val) => {
      this.sidebarMenu = JSON.parse(JSON.stringify(val));

      this.filterSidebarMenu = this.appService.filterSidebarAllowed(this.sidebarMenu, this.roles);
    });
    this.Subscriptions.add(getSidebarMenu$);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['roles'] && changes['roles'].currentValue) {
      this.filterSidebarMenu = this.appService.filterSidebarAllowed(this.sidebarMenu, this.roles);
    }
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.Subscriptions?.unsubscribe();
  }

  // currentAgentChanged(): void {
  //   if (!this.currentAgent) {
  //     return;
  //   }

  // }
}
